/**
 * @description Plays a video on a shared video element
 *  @internal This is an internal class utilized by the TransitionSequence
 */
class TransitionVideoPlayer {

    constructor(radio, elements, transition) {
        this.radio = radio;
        this.id = transition.id;
        this.container = elements.container;
        this.videoElement = elements.video;
        this.posterCtx = elements.ctx;
        this.src = transition.src;
        this.poster = transition.poster;
        this.defineEvents();   
    }
    defineEvents () {
        this.eventHandlers = {
         
            "ended": ()=>{
                this.unbind();
                this.radio.$emit("ended");
            }
        }
    }
    bind () {
        Object.keys(this.eventHandlers).forEach(event => {
            this.videoElement.addEventListener(event, this.eventHandlers[event]);
        })
    }
    unbind () {
        Object.keys(this.eventHandlers).forEach(event => {
            this.videoElement.removeEventListener(event, this.eventHandlers[event]);
            this.eventHandlers[event] = null;
        })
        delete this.videoElement 
        delete this.eventHandlers;
        
    }

    play () {
        
        // this is to slow to wait for the load event on slow internet
        // we want to show the (poster) video at the get go.
        this.container.classList.add('transition-video--visible');

        this.bind();


        if(config.VIDEO_TRANSITIONS.useImageCacheForPosterImages) {
            const canvasPoster = app.ImageCache.getAsset(this.poster).content
            this.posterCtx.drawImage(canvasPoster, 0, 0);
        }else {

            this.videoElement.poster = this.poster;
            this.videoElement.style.backgroundImage = `url(${this.poster})`;
        }
        
        
        this.videoElement.currentTime = 0;
        this.videoElement.src = this.src;
        
        // why the catch? 
        // https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
        this.videoElement.play().then(()=> {}).catch(e => {})
            
        
 
    }

    
}


